import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

function computeParts(target) {
  if (!target) return null;
  const t = new Date(target).getTime();
  const now = Date.now();
  const diff = t - now;
  if (diff <= 0) return { done: true };
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  return { days, hours, minutes, done: false };
}

export function Countdown({ target, variant = "light" }) {
  const [parts, setParts] = useState(() => computeParts(target));

  useEffect(() => {
    setParts(computeParts(target));
    const it = setInterval(() => setParts(computeParts(target)), 60_000);
    return () => clearInterval(it);
  }, [target]);

  if (!parts || parts.done) return null;
  const isLight = variant === "light";
  const color = isLight ? "text-white/85" : "text-[#0B192C]";
  const border = isLight ? "border-white/25" : "border-[#0B192C]/20";
  const bg = isLight ? "bg-white/5 backdrop-blur-md" : "bg-white";

  return (
    <div
      data-testid="countdown"
      className={`inline-flex items-center gap-3 border ${border} ${bg} px-4 py-2 text-[11px] tracking-[0.2em] uppercase ${color}`}
    >
      <Clock size={12} strokeWidth={1.5} />
      <span className={isLight ? "text-white/60" : "text-neutral-500"}>Iscrizioni chiudono in</span>
      <span className={isLight ? "text-white font-medium" : "text-[#0B192C] font-medium"}>
        {parts.days}g {String(parts.hours).padStart(2, "0")}h {String(parts.minutes).padStart(2, "0")}m
      </span>
    </div>
  );
}
